import root from 'window-or-global';

export const getIsMobileDevice = () => root.Modernizr && root.Modernizr.touch && document.body.clientWidth < 768;



// WEBPACK FOOTER //
// ./src/common/utils/ModernizrUtils.js